import gql from 'graphql-tag';

export const GET_SST_STATE = gql`
query($id: String!) {
  sst(id: $id) {
    connection_state { connected, timestamp }
  }
}
`;